import { useTranslation } from 'react-i18next';
import { getItemColor } from '@helpers/items';
import * as Shared from '@shared/lib';

interface LootInfoProps {
  planet?: string;
  mission?: number;
}

export function LootInfo({ planet, mission }: LootInfoProps) {
  const { t } = useTranslation();

  const data = Shared.planetData.find((p) => p.name === planet);
  if (!data) return null;

  const missionData = data?.missions?.find((_, i) => i === mission);
  const faction = missionData?.faction || data.faction || 'Aegis';

  const possibleLoot = Shared.itemData
    .filter((l) => !l.crafting)
    .filter((l) => !l.planet || l.planet === planet)
    .filter((l) => !l.faction || l.faction === faction);
  if (!planet || possibleLoot.length === 0) return null;

  const fishLoot = data.type === 'fishing' && Shared.fishData;
  const miningLoot = data.type === 'mining' && Shared.oreData;

  const totalLoot = [
    ...(fishLoot || []),
    ...(miningLoot || []),
    ...possibleLoot
  ].filter(l => ![Shared.ItemCode.ENERGY, Shared.ItemCode.HEALTH].includes(l.id));

  return (
    <div className="p-2 relative border-b border-secondary bg-black/40 lootinfo">
      <div className="absolute inset-0 grid-overlay" />
      <div className="flex flex-col justify-between text-left h-full w-full relative">
        <p className="text-lg leading-tight">{t('LootInfo.title')}</p>
        <p className="text-gray-300 text-xs mt-1 pr-8">
          {totalLoot.map((l, i) => (
            <span className={getItemColor(l)} key={l.key}>
              {t(`Items.${l.key}`)}
              {i < totalLoot.length - 1 ? ', ' : ''}
            </span>
          ))}
        </p>
      </div>
    </div>
  );
}